import React, { useCallback, useState, useEffect } from 'react';
import { Container } from '../../react/components/index.web';
import { styleTypeToObject } from '../../styles/functions.web';
export const DEFAULT_ICON_COLOR = navigator.product === 'ReactNative' ? 'white' : undefined;
export const DEFAULT_ICON_SIZE = navigator.product === 'ReactNative' ? 36 : 40; // 22
export const DEFAULT_ICON_SIZE_CLASS = navigator.product === 'ReactNative' ? 'size-small' : undefined;
/**
 * Implements an Icon component that takes a loaded SVG file as prop and renders it as an icon.
 *
 * @param {IProps} props - The props of the component.
 * @returns {ReactElement}
 */
export default function Icon(props) {
    const { alt, className = '', color, id, containerId, onClick, size, src: IconComponent, style, ariaHasPopup, ariaLabel, ariaDisabled, ariaExpanded, ariaControls, tabIndex, ariaPressed, ariaDescribedBy, role, onKeyPress, onKeyDown, testId, ...rest } = props;
    const [iconColor, setColor] = useState(DEFAULT_ICON_COLOR);
    const [hasColorChanged, setHasColorChanged] = useState(false);
    const [iconSize, setSize] = useState(DEFAULT_ICON_SIZE);
    const [sizeClassName, setSizeClassName] = useState(DEFAULT_ICON_SIZE_CLASS);
    const elements = document.querySelectorAll('.jitsi-icon svg:not(.settings-button-small-icon svg, #participant-connection-indicator svg, #mic-disabled, #toggleFilmstripButton svg)');
    useEffect(() => {
        const applyStyles = (iconColor, sizeClassName) => {
            try {
                elements.forEach((icon) => {
                    if (iconColor != null && iconColor != '' && iconColor != undefined) {
                        // @ts-ignore
                        icon.parentElement.classList.add(iconColor);
                    }
                    if (sizeClassName != null && sizeClassName != '' && sizeClassName != undefined) {
                        // @ts-ignore
                        icon.parentElement.classList.add(sizeClassName);
                    }
                    // if (icon instanceof HTMLElement) {
                    //     icon.style.fill = iconColor;
                    //     icon.style.width = `${iconSize}px`;
                    //     icon.style.height = `${iconSize}px`;
                    // } else if (icon instanceof SVGElement) {
                    //     icon.setAttribute('fill', iconColor);
                    //     icon.style.width = `${iconSize}px`;
                    //     icon.style.height = `${iconSize}px`;
                    // }
                });
            }
            catch (err) {
                console.log('Error re-applying styles:', err);
            }
        };
        // @ts-ignore
        window.addEventListener('resize', applyStyles(iconColor, sizeClassName));
        // Apply styles initially
        // @ts-ignore
        applyStyles(iconColor, sizeClassName);
        return () => {
            // window.removeEventListener('resize', applyStyles);
        };
    }, [iconColor, sizeClassName]);
    useEffect(() => {
        if (iconColor != null && iconColor != '' && iconColor != undefined) {
            localStorage.setItem('icon_color_class', JSON.stringify(iconColor));
            console.log("localStorage.getItem('icon_color_class') is now:", localStorage.getItem('icon_color_class'));
        }
        if (sizeClassName != null && sizeClassName != '' && sizeClassName != undefined) {
            localStorage.setItem('icon_size_class', JSON.stringify(sizeClassName));
            console.log("localStorage.getItem('icon_size_class') is now:", localStorage.getItem('icon_size_class'));
        }
    }, [iconColor, sizeClassName]);
    useEffect(() => {
        try {
            let iconData;
            if (window.localStorage.getItem('icon_color_class'))
                iconData = window.localStorage.getItem('icon_color_class');
            if (iconData != null && iconData != '' && iconData != undefined && iconData != 'undefined')
                setColor(JSON.parse(iconData));
        }
        catch (err) {
            console.log('error getting/parsing iconData in local storage:', err);
        }
        try {
            let sizeData;
            if (window.localStorage.getItem('icon_size_class'))
                sizeData = window.localStorage.getItem('icon_size_class');
            if (sizeData != null && sizeData != '' && sizeData != undefined && sizeData != 'undefined')
                setSizeClassName(JSON.parse(sizeData));
        }
        catch (err) {
            console.log('error getting/parsing sizeData in local storage:', err);
        }
    }, []);
    // @ts-ignore
    const { color: styleColor, fontSize: styleSize, ...restStyle } = styleTypeToObject(style ?? {});
    const calculatedColor = color ?? styleColor ?? DEFAULT_ICON_COLOR;
    const calculatedSize = size ?? styleSize ?? DEFAULT_ICON_SIZE;
    const onKeyPressHandler = useCallback((e) => {
        if ((e.key === 'Enter' || e.key === ' ') && onClick) {
            e.preventDefault();
            onClick(e);
        }
        else if (onKeyPress) {
            onKeyPress(e);
        }
    }, [onClick, onKeyPress]);
    const jitsiIconClassName = calculatedColor ? 'jitsi-icon' : 'jitsi-icon jitsi-icon-default';
    const iconProps = alt
        ? {
            'aria-label': alt,
            role: 'img'
        }
        : {
            'aria-hidden': true
        };
    let dataSize;
    let dataColor;
    let size_class = {
        36: 'size-small',
        48: 'size-medium',
        60: 'size-large'
    };
    window.addEventListener('message', function (event) {
        if (typeof event.data === 'string' && event.data.includes('Selected jitsi-icon color: ')) {
            console.log('Message received from the parent: ' + event.data); // Message received from parent
            dataColor = event.data.split(': ')[1].toString().trim();
            if (dataColor) {
                setColor(dataColor);
                setHasColorChanged(true);
            }
        }
        if (typeof event.data === 'string' && event.data.includes('Selected jitsi-icon size: ')) {
            console.log('Message received from the parent: ' + event.data); // Message received from parent
            dataSize = parseInt(event.data.split(': ')[1].toString().trim());
            for (let key in size_class) {
                let x = parseInt(key);
                if (x === dataSize) {
                    setSizeClassName(size_class[x].toString());
                }
            }
            if (dataSize)
                setSize(dataSize);
        }
    });
    return (React.createElement(Container, { ...rest, "aria-controls": ariaControls, "aria-describedby": ariaDescribedBy, "aria-disabled": ariaDisabled, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, "aria-label": ariaLabel, "aria-pressed": ariaPressed, className: !hasColorChanged
            ? `${jitsiIconClassName} ${className || ''}`
            : `${className || ''} ${iconColor || ''} ${sizeClassName || ''}`, "data-testid": testId, id: containerId, onClick: onClick, onKeyDown: onKeyDown, onKeyPress: onKeyPressHandler, role: role, style: restStyle, tabIndex: tabIndex },
        React.createElement(IconComponent, { ...iconProps, className: `${iconColor} ${sizeClassName}`, fill: calculatedColor, height: calculatedSize, id: id, width: calculatedSize })));
}
